import React, { useEffect, useState } from "react";
import "./index.css";
import "core-js/stable";
import "regenerator-runtime/runtime";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VoiceBot from "./pages/VoiceBot";
import VideoChatPage from "./heroPlugin/VideoChatPage";
import Test from "./heroPlugin/Test";
import Chat from "./components/Chat/Chat";
import Participants from "./components/Chat/Participants";
import ChatHistory from './components/Chat/ChatHistory';
import NewChat from './components/Chat/NewChat';
// import VoiceBot from "./components/VoiceBot/VoiceBot";
import FormGenerator from "./SheetForm/FormGenerator";
import UpdateForm from "./SheetForm/UpdateForm";
import UserForm from "./SheetForm/UserForm";
import FormLogin from "./SheetForm/FormLogin";
// import GoogleDocsFetcher from "./SheetForm/GoogleDocsFetcher";
// import Sun from './SheetForm/sun';
// import VoiceBot from './components/VoiceBot'; // Adjust the path to your component
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { ThemeProvider } from './contexts/ThemeContext';
import { ChatbotConfigProvider } from "./contexts/ChatbotConfigContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { customBranding } from "./config/config";
// firebase
import { generateToken, messaging } from "./notifications/firebase";
import { onMessage } from "firebase/messaging";
import { initializeNotifications, setupMessageListener } from './notifications/firebase'; // Update path as needed
import { useReminderChecker, useVisibilityHandler, registerServiceWorker } from './utils/ReminderChecker';
import NotificationComponent from './notifications/NotificationComponent';


const App = () => {
    React.useEffect(() => {
        // Set the CSS variables for primary color and scrollbar color dynamically

        document.documentElement.style.setProperty(
            "--scrollbar-color",
            customBranding.scrollbarColor
        );
        document.documentElement.style.setProperty(
            "--scrollbar-track-color",
            customBranding.scrollbarTrackColor
        );
    }, []);

    const [notification, setNotification] = useState(null);

    useEffect(() => {
        generateToken();
        onMessage(messaging, (payload) => {
            console.log(payload);
            toast.success(`${payload.notification.title}: ${payload.notification.body}`);
        })

        // Initialize Firebase notifications
        initializeNotifications();
        
        // Set up message listener for foreground notifications
        setupMessageListener(setNotification);
    }, []); 

    const clearNotification = () => {
        setNotification(null);
    };

    // Use the custom hooks for reminder checking
    useReminderChecker();
    useVisibilityHandler();

    // Register service worker on app initialization
    useEffect(() => {
        registerServiceWorker();
    }, []);

    return (
        <BrowserRouter>
            <ChatbotConfigProvider>
                <LanguageProvider>
                <Routes>
                    <Route path="/" element={<VoiceBot />} />
                    <Route path="/test" element={<Test />} />
                    <Route path="/video" element={<VideoChatPage />} />
                    <Route path="/chat/:conversation_id" element={<Chat />} />
                    <Route path="/participants" element={<Participants />} />
                    <Route path="/newchat/:conversationId" element={<NewChat />} />
                    <Route path="/chat-history" element={<ChatHistory />} />
                    <Route path="/form-generator" element={<FormGenerator />} />
                    <Route path="/form-update" element={<UpdateForm />} />
                    <Route path="/form/:formId" element={<UserForm />} />
                    <Route path="/form-login" element={<FormLogin />} />
                    {/* <Route
                        path="/GoogleDocsFetcher"
                        element={<GoogleDocsFetcher />}
                    /> */}
                    {/* <Route path="/sun" element={<Sun />} /> */}
                </Routes>

                <NotificationComponent 
                    notification={notification} 
                    onClose={clearNotification} 
                />
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                </LanguageProvider>
            </ChatbotConfigProvider>
        </BrowserRouter>
    );
};

export default App;
